import axios from "axios";

export default class LoadMore {
  
  constructor() {
    if (this.setVars()) {
      this.setEvents();
      this.is_loading = false;
      this.setLabelButton();
    }
  }
  
  setVars() {
    
    this.settings = {
      'main': 'data-load-more',
      'wrapper': 'data-load-more-wrapper',
      'button': 'data-load-more-button',
      'button_label': 'data-load-more-button-label',
      'button_label_is_loading': 'data-load-more-button-label-loading',
      'button_label_is_loaded': 'data-load-more-button-label-loaded',
      'offset': 'data-load-more-offset',
      'page': 'data-load-more-page',
      'url': 'data-load-more-url',
      'post_type': 'data-load-more-post-type',
      'term_id': 'data-load-more-term-id',
      'tag_id': 'data-load-more-tag-id',
    };
    
    this.load_more = document.querySelector(`[${this.settings.main}]`);
  
    if (!this.load_more) return;
  
    this.post_type = this.load_more.getAttribute(this.settings.post_type);
    this.url = this.load_more.getAttribute(this.settings.url);
    this.offset = this.load_more.getAttribute(this.settings.offset);
    this.page = this.load_more.getAttribute(this.settings.page);
    this.term_id = this.load_more.getAttribute(this.settings.term_id);
    this.tag_id = this.load_more.getAttribute(this.settings.tag_id);
    
    this.button_label_is_loading = this.load_more.getAttribute(this.settings.button_label_is_loading);
    this.button_label_is_loaded = this.load_more.getAttribute(this.settings.button_label_is_loaded);
    
    this.all = 0;
    
    return true;
  }
  
  setEvents() {
    this.button = this.load_more.querySelector(`[${this.settings.button}]`);
    
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      this.is_loading = true;
      this.setLabelButton();
      
      this.page++;
      
      axios.get(this.url, {
        params: {
          post_type: this.post_type,
          paged: this.page,
          term_id: this.term_id,
          tag_id: this.tag_id,
        }
      })
        .then( (response) => {
          response.data.items.forEach((item) => {
            const parser = new DOMParser();
            const dragged = parser.parseFromString(item, 'text/html');
            const divDoc = dragged.getRootNode();
            this.load_more.querySelector(`[${this.settings.wrapper}]`).appendChild(divDoc.body.firstChild);
          });
  
          this.offset = this.offset * this.page;
          this.all = response.data.all_posts;
          this.is_loading = false;
          this.setLabelButton();
          
          if (this.all <= this.offset) {
            this.button.removeClass('active')
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      
    });
  }
  
  setLabelButton() {
    const label_button = this.button.querySelector(`[${this.settings.button_label}]`);
    
    if (this.is_loading) {
      label_button.innerHTML = this.button_label_is_loading;
    } else {
      label_button.innerHTML = this.button_label_is_loaded;
    }
  }
}
